export default {
  getResumes(state) {
    return state.allResumes;
  },

  getCoverLetter(state) {
    return state.allCoverLetters;
  },
};
